@if (dtcValues && dtcValues.length > 0) {
  <ul
    class="text-sm font-medium border rounded-lg bg-gray-700 border-gray-600 text-white max-h-60 py-2 overflow-y-auto"
  >
    @for (value of dtcValues; track $index) {
      <li
        [ngClass]="{
          'border-b': dtcValues && $index !== dtcValues.length - 1,
          'border-b-lg': dtcValues && $index === dtcValues.length - 1,
        }"
        class="w-full px-4 py-2 border-b border-gray-200 rounded-t-lg dark:border-gray-600"
      >
        <a [routerLink]="['/dtc/edit/', value.id]" routerLinkActive="router-link-active">
          <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 cursor-pointer">
            {{ value.dtc }}
            <div class="flex justify-end">
              <app-open-page></app-open-page>
            </div>
          </div>
        </a>
      </li>
    }
  </ul>
}
